import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  GetDetailsResponseSchema,
  MediaRowSchema,
  PreviewQuerySchema,
} from './schemas.js';

export const getDetails = defaultClient.query({
  url: 'datintell/v1/campaigns/detail/$rowId/',
  method: 'GET',
  responseSchema: GetDetailsResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const getMediaRowsListQueryOptions = defaultClient.query({
  url: 'datintell/v1/builder/media_rows/preview/' as const,
  method: 'GET',
  snakeCaseQueryParams: true,
  querySchema: PreviewQuerySchema,
  responseSchema: z.array(MediaRowSchema),
  processResponse(data) {
    return data;
  },
});
